import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-research-development-cell',
    templateUrl: './research-development-cell.component.html',
    styleUrls: ['./research-development-cell.component.scss']
})
export class ResearchDevelopmentCellComponent implements OnInit {
    src: string = '/assets/pdf/research/Research Development Cell.pdf';
    title: string = 'Research & Development Cell';

    constructor() { }

    ngOnInit(): void {
    }

}
